import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: ['dns'],
  data: function data() {
    return {
      customizeDNS: [{}]
    };
  },
  methods: {
    //添加输入框
    addcustomizeDNS: function addcustomizeDNS() {
      this.customizeDNS.push({
        value: ""
      });
    },
    //删除输入框与内容
    remcustomizeDNS: function remcustomizeDNS(index) {
      this.customizeDNS.splice(index, 1);
    },
    //字符串转换成可用的数组格式函数
    StringOrArray: function StringOrArray(str) {
      var Arr = [];
      var ArrValue = str.split(' ');
      ArrValue.forEach(function (val, index) {
        Arr.push({
          value: val
        });
      });
      return Arr;
    },
    //数组转换成可用的字符串格式上传
    ArrayOrString: function ArrayOrString(Arr) {
      var Str = ''; //循环传入的数组

      Arr.forEach(function (val, index) {
        //如果数组下的值不为空,拼接成字符串上传
        if (val.value !== '') {
          //判断是不是最后一个数组，如果是不用' '隔开字符串
          if (index !== Arr.length - 1) {
            Str += val.value + ' ';
          } else {
            Str += val.value;
          }
        }
      });
      return Str;
    }
  },
  mounted: function mounted() {
    //如果dns不等于''或undefined
    if (this.dns) {
      this.customizeDNS = this.StringOrArray(this.dns);
    }
  },
  watch: {
    customizeDNS: {
      handler: function handler(newvalue, oldValue) {
        //判断是否为空
        if (newvalue !== '') {
          var Value = this.ArrayOrString(this.customizeDNS);
          this.$emit('GetAddInput', Value);
        }
      },
      deep: true
    },
    dns: {
      handler: function handler(newValue, oldValue) {
        if (oldValue === undefined && newValue) {
          this.customizeDNS = this.StringOrArray(this.dns);
        }
      }
    }
  }
};